import {formatToIndianNumber} from '../../../utils/common'

export const parseCalendarEvents = (data: any[]) => {
  if (!data) return []

  return data.map((item: any) => {
    const hasPayment = item.amount_payable !== null && item.amount_payable > 0
    const amount = item.amount_payable || 0

    return {
      id: item.date,
      title: hasPayment
        ? `${formatToIndianNumber(amount)} | ${item.unique_po_count} POs`
        : `${item.unique_po_count} POs`,
      date: item.date,
      textColor: hasPayment ? '#000000' : '#666666',
      extendedProps: {
        totalAmount: amount,
        poCount: item.unique_po_count,
        hasPayment: hasPayment,
        date:item.date
      },
    }
  })
}

export const parseDateDetails = (data: any) => {
  if (!data) return {}

  return {
    id: data.id,
    poNumber: data.po_number || '-',
    poDate: data.po_date || '',
    supplierName: data.supplier_name || '-',
    companyName: data.company_name || '-',
    makePayment: data.make_payment || '',
    totalAmount: data.total_amount || '',
    paidAmount: data.paid_amount || '',
    remainingAmount: data.remaining_amount || '',
  }
}

export const parsePaymentListData = (data: any) => {
  if (!data) return {}

  return {
    id: data.id,
    scheduleDate: data.schedule_payment_date || '',
    poNumber: data.po_number || '-',
    poDate: data.po_date || '',
    supplierName: data.supplier_name || '-',
    companyName: data.company_name || '-',
    makePayment: data.make_payment || '',
    totalAmount: data.total_amount || '',
    paidAmount: data.paid_amount || '',
    remainingAmount: data.remaining_amount || '',
  }
}

export const parsePaymentSummary = (data: any[]) => {
  if (!data || data.length === 0) {
    return {
      totalMakePayment: 0,
      totalAmount: 0,
      totalPaidAmount: 0,
      totalRemainingAmount: 0,
    }
  }

  return {
    totalMakePayment: data.reduce((sum, item) => sum + (item.make_payment || 0), 0),
    totalAmount: data.reduce((sum, item) => sum + (item.total_amount || 0), 0),
    totalPaidAmount: data.reduce((sum, item) => sum + (item.paid_amount || 0), 0),
    totalRemainingAmount: data.reduce((sum, item) => sum + (item.remaining_amount || 0), 0),
  }
}
